export const moveMethods = {}



// WEBPACK FOOTER //
// ./src/layout/components/tree/tree-store/move.js